import * as popup from './popup';
import * as sign from './sign';
import * as deals from './deals';
import * as tariff from './tariff';
import * as settings from './settings';

async function changeStates( store, states ) {

  store.setState( states );

}

async function changeObjectState( store, object, state, value ) {

  store.setState({

    [ object ]: {

      ...store.state[ object ],
      [state]: value

    }

  });

}

export {

  changeStates,
  changeObjectState,
  popup,
  sign,
  deals,
  tariff,
  settings,
  
}